import React from 'react';

import { ReactComponent as CloseIcon } from "../../svg/close-icon.svg";
import * as Styled from './EventOverlay.styles';
import { pageMotionProps } from 'utils/styles/animations';
import GradientLine from 'components/GradientLine/GradientLine';
import useGlobalStore from 'utils/store';
import Counter from 'components/Counter/Counter';
import ButtonCta from 'components/ButtonCta/ButtonCta';

export interface EventOverlayProps {
  onClose: () => void,
}

const EventOverlay: React.FC<EventOverlayProps> = ({onClose}) => {
  const { copy } = useGlobalStore();
  return <Styled.Wrapper {...pageMotionProps} >
    <Styled.CloseWrapper>
      <CloseIcon onClick={onClose}/>
    </Styled.CloseWrapper>
    <Styled.Content>
      <Styled.ContentHeader>
        <span>{copy.event.label}</span>
        <span>{copy.event.location}</span>
      </Styled.ContentHeader>
      <GradientLine />
      <Styled.ContentTitle>{copy.event.title}</Styled.ContentTitle>
      <Styled.ContentSubtitle>
        <Styled.ContentSubtitleLeft>{copy.event.subtitle.left}</Styled.ContentSubtitleLeft>
        <Styled.ContentSubtitleDivide />
        <Styled.ContentSubtitleRight>{copy.event.subtitle.right}</Styled.ContentSubtitleRight>
      </Styled.ContentSubtitle>
      <Counter />
      <Styled.CtaWrapper>
        <ButtonCta label={copy.event.cta} onAction={() => console.log('Go to event')} solid={true} onDisabled={false} fullIcon={false} />
        <GradientLine />
      </Styled.CtaWrapper>
    </Styled.Content>

  </Styled.Wrapper>;
};

export default EventOverlay;
